<template>
  <div class="news">
    <Banner :banner="banner" />
    <div class="container">
      <div class="title">
        <div class="cn">企业动态</div>
        <div class="en">Beyond News</div>
      </div>
      <div class="list">
        <div class="item" v-for="item in news" :key="item.ID" @click="goto(item.ID)">
          <div class="detail">
            <div class="in">
              <div class="date">{{item.SHOWTIME.slice(0,10)}}</div>
              <div class="title">{{item.TITLE}}</div>
              <div class="content">{{item.JJ}}</div>
            </div>
            <div class="icon">
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <div class="img">
            <img :src="`http://boyang.sansg.com/upload/${item.SMALLPIC}`" alt="">
          </div>
        </div>
      </div>
      <div class="more">
        <div class="btn" @click="getdata">MORE</div>
      </div>
    </div>

  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
export default {
  components: {
    Banner
  },
  data(){
    return{
      banner:{
        title:'企业动态',
        img:'/images/newsbanner.jpg'
      },
      news:[],
      page:1
    }
  },
  created(){
    this.getdata()
  },
  methods: {
    goto(id){
      this.$router.push({
        name:"newsDetail",
        params:{
          id
        }
      })
    },
    getdata(){
      this.$$axios.get('/php/news.php', {
        params: {
          newstype: '企业动态',
          num:8,
          page:this.page
        }
      })
      .then(res=>{
        this.news=this.news.concat(res.data.newsArr)
        this.page++
      })
      .catch(error=>{
        console.log(error);
      });
    }
  }
}
</script>

<style scoped>
.news{
}
.news .container>.title{
  text-align: center;
  padding: 45px 0;
}
.news .container>.title .cn{
  font-family: '宋体';
  font-size: 30px;
  color: #5e7987;
  margin-bottom: 10px;
}
.news .container>.title .en{
  font-family: 'Embassy BT';
  font-size: 20px;
  color: #636363;
}
.news .list{
  display: flex;
  flex-wrap: wrap;
}
.news .list .item{
  width: 50%;
  display: flex;
  cursor: pointer;
}
.news .list .item .detail{
  width: 50%;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10% 8%;
  transition: 2s;
}
.news .list .item:hover .detail{
  background-color: #5e7987;
  color: #fff;
}
.news .list .item .detail::after{
  content: '';
  position: absolute;
  top: 50%;
  left: 100%;
  width: 0;
  height: 0;
  border-left: 25px solid #fff;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  transition: 2s;
  z-index: 10;
}
.news .list .item:hover .detail::after{
  border-left-color: #5e7987;
}
@media(min-width: 768px){
  .news .list .item:nth-of-type(4n),
  .news .list .item:nth-of-type(4n-1){
    flex-direction: row-reverse;
  }
  .news .list .item:nth-of-type(4n) .detail::after,
  .news .list .item:nth-of-type(4n-1) .detail::after{
    border-left: none;
    border-right: 25px solid #fff;
    left: auto;
    right: 100%;
  }
  .news .list .item:nth-of-type(4n):hover .detail::after,
  .news .list .item:nth-of-type(4n-1):hover .detail::after{
    border-right-color: #5e7987;
  }
}
.news .list .item .detail .in .date{
  font-size: 30px;
}
.news .list .item .detail .in .title{
  font-size: 18px;
  font-weight: lighter;
  margin-top: 30px;
}
.news .list .item .detail .in .content{
  font-size: 14px;
  color: #696969;
  line-height: 30px;
  font-weight: lighter;
  margin-top: 30px;
  text-align: left;
  transition: 2s;
}
.news .list .item:hover .detail .in .content{
  color: #fff;
}
.news .list .item .detail .icon i{
  font-size: 17px;
  transition: 2s;
}
.news .list .item:hover .detail .icon i{
  transform: rotate(180deg);
}
.news .list .item .img{
  width: 50%;
  overflow: hidden;
}
.news .list .item .img img{
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 2s;
}
.news .list .item:hover .img img{
  transform: scale(1.1);
}
.news .more{
  display: flex;
  justify-content: center;
  padding: 50px 0;
}
.news .btn{
  position: relative;
  border: 1px solid #c1cdd5;
  text-align: center;
  display: block;
  width: 260px;
  margin-right: 26px;
  max-width: 100%;
  font-size: 14px;
  font-family: 'Century751';
  padding: 20px 0;
  cursor: pointer;
}
@media(max-width: 768px){
  .news .list .item{
    width: 100%;
    flex-direction: column-reverse;
  }
  .news .list .item .detail,
  .news .list .item .img{
    width: 100%;
  }
  .news .list .item .detail::after{
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 25px solid #fff;
    top: auto;
    left: 50%;
    bottom: 100%;
    margin-top: 0;
    margin-left: -20px;
  }
}
</style>


